module.exports = __webpack_public_path__ + "static/media/security_service_5.636ad27d.png";